import React from "react";
import SmallProjects from "../components/small_projects/Small_projects";
import CompleteApps from "../components/complete-apps/Complete_apps";

const ProjectPage = () => {
  return (
    <>
      <SmallProjects />
      <CompleteApps />
    </>
  );
};

export default ProjectPage;
